<div class="video-wrapper" [class.mr-xsmall-y]="!noMargin()">
  <button
    [class.is-vishidden]="previewVisible() ? null : true"
    [attr.disabled]="previewVisible() ? null : true"
    (click)="playVideo()"
    title="{{ 'playVideo' | finLocalization }}"
    class="preview"
  >
    <fin-block-image [imageData]="youtubePreviewPicture()" [overlay]="true" />
    <fcom-icon [name]="SvgLibraryIcon.YOUTUBE" class="icon-xxlarge preview__play" />
    @if (videoTitle()) {
      <span class="is-vishidden">{{ videoTitle() }}</span>
    }
  </button>
  @if (showPopup()) {
    <fcom-modal [open]="iframeVisible()" [buttons]="ModalButtons.CLOSE" (close)="iframeVisible.set(false)">
      <ng-container [ngTemplateOutlet]="iframe" />
    </fcom-modal>
  } @else {
    <ng-container [ngTemplateOutlet]="iframe" />
  }

  <ng-template #iframe>
    @if (iframeVisible()) {
      <iframe
        #videoIframe
        width="854"
        height="480"
        [src]="videoFinalUrl()"
        frameborder="0"
        [attr.title]="videoTitle() ?? null"
        allow="autoplay; fullscreen"
      ></iframe>
    }
  </ng-template>
</div>
